/** The 01 / 02 / 03 rail from the prototype. */
/**
 * Terms are agreed to during signup, so they are not a step here. The terms
 * screen still exists for re-accepting a revised agreement, and shows its own
 * heading rather than a position in this rail.
 */
const STEPS = [
  { id: "profile", label: "Payment" },
  { id: "finish", label: "Start" },
] as const;

type StepId = (typeof STEPS)[number]["id"] | "terms";

export function OnboardingSteps({ current }: { current: StepId }) {
  const currentIndex = STEPS.findIndex((step) => step.id === current);

  return (
    <nav className="rail" aria-label="Onboarding progress">
      {STEPS.map((step, index) => (
        <div key={step.id} style={{ display: "contents" }}>
          {index > 0 && <div className="seg-line" />}
          <div
            className={`seg ${index === currentIndex ? "active" : ""} ${
              index < currentIndex ? "done" : ""
            }`}
            aria-current={index === currentIndex ? "step" : undefined}
          >
            <span className="n">0{index + 1}</span> {step.label}
          </div>
        </div>
      ))}
    </nav>
  );
}
